<template>
    <div class="about-background">
        <div class="aboutText about">
            <localized-string val="about.description"/>
        </div>
        <div v-if="nextTrail" class="about nextTrail">
            <Trail class="trailInfo" :trail="nextTrail" simpleView="true" edit="false"/>
            <TrailMap class="trailMap"
                      :mapCenter="mapCenter"
                      :trails="trails"
                      :selectedTrailId="this.nextTrail && this.nextTrail.id"/>
        </div>
        <div v-else-if="nextTrail !== undefined" class="about">
            <localized-string val="about.noTrails"/>
        </div>
    </div>
</template>

<script>
  import _ from 'lodash-es';
  import HasherDao from "../daos/HasherDao";
  import TrailDao from "../daos/TrailDao";
  import LocalizedString from "../components/localizedString";

  export default {
    name: 'About',
    components: {LocalizedString},
    data() {
      return {
        nextTrail: undefined
      }
    },
    computed: {
      trails() {
        return [this.nextTrail];
      },
      mapCenter() {
        return {
          lat: this.nextTrail.latitude,
          lng: this.nextTrail.longitude
        };
      }
    },
    created() {
      TrailDao.getNext().then(trail => {
        this.nextTrail = trail;
      })
    }
    // asyncComputed: {
    //   nextTrail: {
    //     default: null,
    //     get: function() {
    //       return TrailDao.getNext();
    //     }
    //   }
    // }
  }


</script>
<style scoped lang="scss">
               //TODO make this override of 100% height better
    .nextTrail .trailInfo {
        height: auto;
    }
    .about-background {
        width: 100%;
        //height: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-direction: column;
        box-shadow: none;
    }

    .about {
        box-sizing: border-box;
        border-radius: 1em;
        @media only screen and (max-width: 868px) {
            border-radius: 0;
        }
        width: 100%;
        max-width: 30em;
        background: rgba(255,255,255,0.95);
        box-shadow: -10px 10px 20px rgba(0, 0, 0, 0.7);
        color: black;
        padding: 1em 1.5em;
        line-height: 1.4;
        font-size: 20px;
        margin: 1em 0 0.5em 0;
        /*p {*/
        /*    margin: 1em 0;*/
        /*    text-indent: 1em;*/
        /*}*/
    }

    .about.aboutText {
        text-align: center;
    }

    .about.nextTrail {
        width: 100%;
        max-height: 32em;
        //flex-basis: 32em; //Why was this here?
        margin: 1em 0;
        padding: 1em;
        line-height: 1.15;

        .trailMap {
            height: auto;
            width: auto;
            min-height: 320px;
            min-width: 320px;
            margin-top: 0.5em;
            @media only screen and (max-width: 320px) {
                //Ignore padding on tiny screens (pretty much just iPhone SE now I think), as google maps min size is 320px
                margin-left: -1em;
                margin-right: -1em;
            }
        }
    }

    @media only screen and (max-width: 568px) {
        .about, .about.nextTrail {
            margin-top: 0;
            margin-bottom: 0;
        }
        .about.nextTrail {
        }
        .about-background {
            justify-content: space-evenly;
        }
    }


</style>
